<style scoped>
ul.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
}
ul.bucket-list li.buckets {
    display: inline-block;
    padding: 5px 20px;
    background: #7C6EB8;
    border-radius: 40px;
    margin-right: 10px;
}
ul.bucket-list li.buckets span {
    color: #ffffff;
}
ul.bucket-list li.no-result {
    display: block;
}
.shadowBox {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    display:inline-block;
    margin:10px;
}
.shadowBox:hover .design-delete {
    display: inline-block !important;
}
</style>
<template>
<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-header with-border">
                <h1 class="box-title"><b>Blocked Keywords</b></h1>
                 <div class="buckets"> 
                        <ul class="bucket-list clearfix">
                            <li v-for="(singleWord,index) in separatedArray" :key="index" class="shadowBox">
                                <span>
                                    {{singleWord}}
                                    <i class="fa fa-remove design-d design-delete" @click="deleteSingleWordSingle(singleWord)"></i>
                                </span>
                            </li>
                        </ul>
                 </div>     
                <!-- <div v-for="(singleWord,index) in separatedArray" :key="index">
                   <label> {{singleWord}}</label>
                </div>
                -->
            </div>
            <div>
                <div class="box">
                    <div class="box-header with-border">
                        <h1 class="box-title"><b>Please add domain specific keywords entries here</b></h1>
                        <div>
                            <textarea placeholder="Enter keywords" rows="4" cols="150" v-model="keywordsData" style="border:1px solid black;padding:10px"></textarea>
                            <div><button @click="addData" type="button" class="btn btn-primary">Submit</button></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            msg: 'charmi',
            uuid: '',
            domId: '',
            keywords: [],
            keywordsData: '',
            separatedArray: []
        }
    },
    created: function () {
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;
        console.log("uuid and domid", this.uuid, this.domId);
        this.getdata();
    },
    methods: {
        deleteSingleWordSingle(singleword){
            let sword = ','+singleword;
            let a = this.keywordsData;
            console.log("replay whole a",a,typeof a);
            console.log("replay",a.replace(sword, " "));
             var finalString = a.replace(sword, " ");
             console.log("replay final",finalString);
             this.keywordsData = '';
             this.keywordsData =finalString;

             this.addData();  

        },
        separateString(originalString) {
            // originalString = "One, Two, Three, Four, Five"; 
            this.separatedArray = originalString.split(',');
            console.log("sarray", this.separatedArray, 'type', typeof this.separatedArray);
            for (var i = 0; i < this.separatedArray.length; i++) {
                console.log("sarraysingle", this.separatedArray[i]);
            }
        },
        getdata() {
            this.keywords = [];
            this.keywordsData = '';
            var api = BASE_URL + `v1/voilated-keyword-block/domain/${this.domId}/`;
            axios.get(api).then(res => {
                this.keywords = res.data;
                this.separateString(this.keywords);
                this.keywordsData = res.data;
            })
        },
        addData() {
            var api = BASE_URL + `v1/voilated-keyword-block/domain/${this.domId}/`;
            let x = {
                'keywords': this.keywordsData
            }
            axios.post(api, x)
                .then(res => {
                    console.log("res", res);
                    this.getdata();
                })
        }
    }
}
</script>


// WEBPACK FOOTER //
// KeywordBlock.vue?71669efa